var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('course-list-item',{attrs:{"last-item":true,"course":_vm.course,"demo-button-text":_vm.courseDemoButtonLabel(_vm.course)},on:{"order":_vm.order,"demo":function($event){return _vm.demo(_vm.course)}}})}
var staticRenderFns = []

export { render, staticRenderFns }